import React, { Component } from 'react';
import styled from 'styled-components';
import companyIcon from 'images/mapClustoer/companyIcon.svg';
import marker_favorite from 'images/mapClustoer/marker_favorite.png';
import ic24 from 'images/mapClustoer/ic24.svg';
import ellipse from 'images/mapClustoer/ellipse.png';
import MarkerClustering from '../ProposalStoreMap/MarkerClustering';

const { naver } = window;

// 클러스터 아이콘은 naver 전역(N)에 의존 → 모듈 로드 시점 말고 호출 시점에 생성
const buildClusterIcons = () => {
  const icon = () => ({
    content: `<div style="cursor:pointer;width:40px;height:40px;line-height:42px;font-size:10px;color:white;text-align:center;font-weight:bold;background:url(${ellipse});background-size:contain;"></div>`,
    size: N.Size(40, 40),
    anchor: N.Point(20, 20)
  });
  return [icon(), icon(), icon(), icon(), icon()];
};

const MapWrapper = styled.div`
  height: 100%;
  width: 98%;
  position: relative;
  background-color: #0bb656;
`;

const MapContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const Button = styled.button`
  position: absolute;
  z-index: 1;
  width: 56px;
  height: 56px;
  margin-left: 12px;
  background: #fff;
  border: 0.5px solid #afb2b9;
  border-radius: 4px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  bottom: 20px;
  cursor: pointer;
`;

// naver SDK 미로드 시 지도 영역 대체 표시
const MapFallback = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #f5f6f7;
  color: #6b6e76;
  font-size: 14px;
  line-height: 1.6;
`;

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      markers: [],
      infoWindows: [],
      markerClustering: null,
      mapUnavailable: false
    };
  }

  componentDidMount() {
    // naver SDK 미로드(점검/503) 시 지도만 대체 표시, 나머지 화면은 정상 동작
    if (!naver || !naver.maps) {
      this.setState({ mapUnavailable: true });
      return;
    }
    const map = this.landingMap();
    this.setState({ map });
    const { office, stores } = this.props;
    this.setMarkerPoint(office.gpsLat, office.gpsLon, map);
    this.setMarkerClusters(stores, map);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!naver || !naver.maps) return;
    const { stores: prevStores = [], storeGps: prevStoreGps, listClickIdx: prevIdx, keyword: prevKeyword } =
      prevProps || {};
    const { stores: currStores = [], storeGps: currStoreGps, listClickIdx: currIdx, keyword: currKeyword } = this.props;
    const { map, markers, infoWindows } = this.state;

    if (prevStores.length !== currStores.length) {
      this.setMarkerClusters(currStores, map);
      if (infoWindows.length !== 0) {
        for (let i = 0; i < infoWindows.length; i++) {
          if (infoWindows[i].getMap()) {
            infoWindows[i].close();
          }
        }
      }
    }

    if (prevIdx !== null && currIdx !== null && prevIdx === currIdx) {
      if (prevKeyword === currKeyword && markers) {
        naver.maps.Event.trigger(markers[currIdx], 'click');
      }
    }

    if (prevStoreGps.gpsLat !== currStoreGps.gpsLat && prevStoreGps.gpsLon !== currStoreGps.gpsLon) {
      const { gpsLat, gpsLon } = currStoreGps;
      const position = new naver.maps.LatLng(gpsLat, gpsLon);
      naver.maps.Event.trigger(markers[currIdx], 'click');
      map.setCenter(position);
    }
  }

  landingMap = () => {
    const mapDiv = document.getElementById('map');
    if (!naver || !naver.maps) {
      return;
    }
    const { office } = this.props;

    const mapData = new naver.maps.Map(mapDiv, {
      useStyleMap: true,
      center: new naver.maps.LatLng(office.gpsLat, office.gpsLon),
      logoControl: false,
      zoom: 16, // 지도의 초기 줌 레벨
      minZoom: 14, // 지도의 최소 줌 레벨
      maxZoom: 20, // 지도의 최대 줌 레벨
      zoomControl: true, // 줌 컨트롤의 표시 여부
      zoomControlOptions: {
        position: naver.maps.Position.TOP_RIGHT
      }
    });

    return mapData;
  };

  setMarkerPoint = (gpsLat, gpsLon, map) => {
    const position = new naver.maps.LatLng(gpsLat, gpsLon);
    map.setCenter(position);

    const companyMarker = new naver.maps.Marker({
      position: new naver.maps.LatLng(gpsLat, gpsLon),
      map,
      icon: companyIcon
    });
  };

  setMarkerClusters = (clusterList, map) => {
    if (!Array.isArray(clusterList)) {
      return;
    }

    const { markerClustering } = this.state;
    const markers = [];
    const infoWindows = [];
    for (let i = 0; i < clusterList.length; i++) {
      const { gpsLat, gpsLon, name } = clusterList[i];
      const position = new naver.maps.LatLng(gpsLat, gpsLon);
      const marker = new naver.maps.Marker({
        position,
        draggable: false
      });
      const infoWindow = new naver.maps.InfoWindow({
        content: `<div style="text-align:center;padding:10px;">${name}</div>`,
        anchorSize: new naver.maps.Size(15, 9),
        borderColor: '#EBEBEC',
        borderWidth: 1,
        borderRadius: 8
      });

      infoWindow.radius = 0;
      marker.setIcon({
        content: `<img src="${marker_favorite}" style="margin: 0px; padding: 0px; border: 0px solid transparent; display: block; max-width: none; max-height: none; -webkit-user-select: none; position: absolute; width: 32px; height: 32px; left: 0px; top: 0px; z-index:1001">`,
        size: new naver.maps.Size(32, 32)
      });

      naver.maps.Event.addListener(marker, 'click', () => {
        if (infoWindow.getMap()) {
          infoWindow.close();
        } else {
          infoWindow.open(map, marker);
        }
      });

      markers.push(marker);
      infoWindows.push(infoWindow);
    }

    if (markerClustering) markerClustering.setMap();

    const newMarkerClustering = new MarkerClustering({
      minClusterSize: 3,
      maxZoom: 20,
      map,
      markers,
      disableClickZoom: false,
      gridSize: 120,
      icons: buildClusterIcons(),
      indexGenerator: [10, 20, 50, 100, 200],
      stylingFunction(clusterMarker, count) {
        $(clusterMarker.getElement())
          .find('div:first-child')
          .text(count);
      }
    });

    this.setState({ markers, markerClustering: newMarkerClustering, infoWindows });
  };

  onClick = () => {
    const { map } = this.state;
    const { office } = this.props;
    const { gpsLat, gpsLon } = office;
    const position = new naver.maps.LatLng(gpsLat, gpsLon);
    map.setCenter(position);
  };

  render() {
    const { mapUnavailable } = this.state;
    return (
      <MapWrapper>
        {!mapUnavailable && (
          <Button onClick={this.onClick}>
            <img src={ic24} alt="ic24" />
          </Button>
        )}
        <MapContainer id="map" />
        {mapUnavailable && (
          <MapFallback>
            지도를 불러올 수 없습니다.
            <br />
            잠시 후 다시 시도해 주세요.
          </MapFallback>
        )}
      </MapWrapper>
    );
  }
}

export default React.memo(Map);
